import qs from "qs";
import request from "@/utils/request";
/* 首页 - 查询分页菜单分类 */
export function homeClassApi(data) {
  return request({
    url: "/query/parent/menu/category",
    method: "get",
    params: data,
  });
}

/** 顶部导航 */
export function navClassApi(data) {
  return request({
    url: "/query/nav/menu/category",
    method: "get",
    params: data,
  });
}

/** 底部导航 */
export function getFooterApi(params) {
  return request({
    url: "/query/menu/bottom",
    method: "get",
    params: params,
  });
}
